import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import MediaEditor from '../../../components/Editor/MediaEditor';
import { getPageEditableLinksIds } from '../selectors';
import { IndesignMediaElementConfig } from '../utils/indesignEditor/editableMedia/getData';
import { HtmlMediaElementConfig } from '../utils/htmlEditor/editableMedia/getData';

const isPropInData = (prop: string, data: IndesignMediaElementConfig | HtmlMediaElementConfig): boolean => (
	prop in data ? data[prop] : undefined
);

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		editor: {
			type: editorType,
			editableMedia,
			editableLinks,
			activeItem,
			editPanel: { isDisplayed: isEditPanelDisplayed },
		},
		importManager: { byId },
	} = state;

	if (ownProps.isCustom) {
		return {};
	}

	const { page, id } = ownProps;
	const data = editableMedia[page][id];
	const {
		type,
		frameWidth,
		frameHeight,
		canDragAndResize,
		importManagerId,
		defaultLink,
		driveLink,
		externalLink,
		isExternalLinkActive,
	} = data;
	const editableLinksIds = getPageEditableLinksIds(state);
	const hasLink = editableLinksIds.includes(id);
	const importManagerItem = byId[importManagerId];
	const isProcessingVideo = !!importManagerItem && !!importManagerItem.isProcessing;

	return {
		editorType,
		type,
		frameWidth,
		frameHeight,
		canDragAndResize,
		isActive: id === activeItem.id,
		isEditPanelDisplayed,
		hasLink,
		linkValue: hasLink ? editableLinks[page][id].href : undefined,
		isProcessingVideo,
		isDefaultMedia: isExternalLinkActive ? externalLink === defaultLink : !driveLink,
		frameAspectRatio: isPropInData('frameAspectRatio', data),
		defaultStyle: isPropInData('style', data),
	};
};

export default connect(mapStateToProps)(MediaEditor);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/MediaEditor/index.tsx